<template>
<!-- 县域专区 -->
  <div>
    <div id="countyCollections" v-if="showPage">
      <div class="top-header">
        <div class="header-bg">
          <div class="search">
            <i class="icon iconfont iconsousuo search-icon"></i>
            <input @focus="searchHandler" class="allInput searchBar" type="text" style="padding: 0 30px 0 33px!important;">
            <i class="icon iconfont iconguanbi empty-icon"></i>
          </div>
          <div :class="{'top-menu': true, 'top-menu-active': showHeadMenu}" @click="toggleHeadMenu">
            <i :class="{'icon':true, 'iconfont':true, 'iconhanbaocaidan': true, 'menu-icon':true, 'menu-icon-active': showHeadMenu}" style="font-size: 20px!important;"></i>
            <!-- 隐藏菜单 -->
            <div v-show="showHeadMenu" class="top-menu-list">
              <div style="" @click="goFavoritesPage">
                <i class="icon iconfont iconshuqian" style="color: #E71222;"></i>
                <span style="margin-left: 5px;font-size: 14px;">我的收藏</span>
              </div>
              <div style="margin-top:15px;" @click="goPersonalPage">
                <i class="icon iconfont icongerenzhongxin1" style="color: #E71222;"></i>
                <span style="margin-left: 5px;font-size: 14px;">个人中心</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="carousel-container" v-show="showCarousel">
        <swiper
          id="carousel-list"
          v-if="carouselList.length > 0"
          :options="swiperOption"
          ref="mySwiper"
          class="carousel-list">
            <swiper-slide  class="my-swp-silde" v-for="(slide, index) in carouselList" :key="index" data-id="slide.articleId" @click.native="goJumpLink($event,slide,false)">
                <img class="my-swp-img" :src="baseUrl + '/api/Article/file/' + slide.fileID" alt="">
                <div class="my-slide-name">{{slide.title}}</div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      

      <!-- <div id="u40" class="ax_default">
                <img id="u40_img" class="img " src="../../assets/countyImg1.png" tabindex="0">
                <div id="u40_text" class="text " style="display:none; visibility: hidden">
                  <p></p>
                </div>
              </div> -->

      <div class="artical-container">
        <!-- <div class="imgLink" style="">
          <img style="width:100%" src="../../assets/countyImg1.png" />
          <div class="leftBox">
            <span class="leftBoxTop" style="">实用工具</span>
            <span class="leftBoxBottom">DRG、DIP及医保计算器&nbsp;&nbsp; &gt;</span>
          </div>
        </div> -->
        <div v-if='false' class="toolBox">
          <img style="height:24px;position:absolute;top:3px;" src="../../assets/countyText.png"/>
          <div class="toolBoxInside">
            <div @click="toolClick('1')" class="DRGItem">
              <img style="height:50px" src="../../assets/countyDRG.png"/>
              <div>DRG工具</div>
            </div>
            <div @click="toolClick('2')" class="DRGItem">
              <img style="height:50px" src="../../assets/countyDIP.png"/>
              <div>DIP工具</div>
            </div>
            <div @click="toolClick('3')" class="DRGItem">
              <img style="height:50px" src="../../assets/countyYiBao.png"/>
              <div>医保计算器</div>
            </div>
          </div>
        </div>
        
        
        <div class="artical-header">
          
          <div class="recommend">
            <!-- <i class="icon iconfont iconwanshangcopy" style="color: #E71222;font-size: 30px!important;font-weight: bold;line-height: 30px;"></i>
            <span class="recommend-txt" style="margin-left:0;">推荐</span> -->

            <!-- <div class="d_in v_m m_r_10">
              <input v-model="isHot" id="testSwitch" @change="changeIsNew" class="allSwitchIsNew" type="checkbox">
              <label for="testSwitch" class="split_2">
                <div style="text-align: center;line-height: 30px" class="v_m c_fff">最新</div>
                <div style="text-align: center;line-height: 30px" class="v_m c_fff">最热</div>
              </label>
            </div>

            <div class="d_in v_m m_r_10">
              <input v-model="isPromotion" id="testSwitch1" @change="changeIsPromotion" class="allSwitchIsNew2" type="checkbox">
              <label for="testSwitch1" class="split_2">
                <div style="text-align: center;line-height: 30px" class="v_m c_fff">产品知识</div>
                <div style="text-align: center;line-height: 30px" class="v_m c_fff">疾病教育</div>
              </label>
            </div> -->
            <div class="tabParent">
              <div :class="{'tabActive': activeTab==0, 'tabNomal': activeTab!=0}" class="tabChild1 tabActive" @click="changeTab(0)">全部文章</div>
              <div :class="{'tabActive': activeTab==1, 'tabNomal': activeTab!=1}" class="tabChild2 tabActive" @click="changeTab(1)">卓越智管</div>
              <div :class="{'tabActive': activeTab==2, 'tabNomal': activeTab!=2}" class="tabChild3 tabActive" @click="changeTab(2)">白话前沿</div>
              <div :class="{'tabActive': activeTab==3, 'tabNomal': activeTab!=3}" class="tabChild4 tabActive" @click="changeTab(3)">指南解读</div>
            </div>
          </div>


          <div style="position: relative;">
            <div class="interest" @click="openFieldsList($event)">
              <i class="icon iconfont iconaixin" style="color: #E71222;font-size: 20px!important;font-weight: bold;line-height: 30px;"></i>
              <span class="interest-txt">兴趣</span>
            </div>
            <!-- 感兴趣的领域 -->
            <!-- <div class="indicationList" v-show="showFieldsList" @click.stop="test">
              <div style="text-align: center;margin-bottom: 5px;">筛选您感兴趣的领域</div>
              <ul>
                <li v-for="(item, index) in fieldsList" :key="index" :class="{'active':item.checked}" @click.stop="chooseFields(item)" :style="item.name=='心脑血管及代谢领域'?'display:none;':''">
                  {{item.name}}
                </li>
              </ul>
            </div> -->
            <van-popup class="popup1" @open="popupOpen()" @closed="popupClosed()" v-model="showTag" position="bottom" :style="{height:'100%'}" closeable close-icon='down'>
              <div class="popupAll">
                <div class="popupHead">
                  <span style="margin-left:8%;margin-top:3.2vh;display:inline-block">选择你感兴趣的领域</span>
                </div>

                <div class="popupBody">
                  <span style="margin-left:4.03%;margin-top:2.9vh;display:inline-block;font-weight: bold;font-size:1.067rem;color:#1a1a1a">治疗领域</span>
                  <span style="margin-top:3vh;display:inline-block;font-size:0.8667rem;color:#1a1a1a">(点击选择感兴趣的领域)</span>
                  <van-collapse v-model="activeNames">
                    <van-collapse-item name="1">
                      <template #title>
                        <div style="display:flex;align-items: center;margin-left:-1%;margin-right:2%">
                          <img v-show="!activeNames.includes('1')" style="height:3vh;" src="../../assets/tagImg/xiaohua1.png" />
                          <img v-show="activeNames.includes('1')" style="height:3vh;" src="../../assets/tagImg/xiaohua2.png" />
                        </div>
                        <span>消化领域</span>
                      </template>
                      <span class="collapseItemH">选择感兴趣的适应症:</span>
                      <div class="collapseItemB">
                        <div class="tagItem" @click="selectTag(item)" :class="{collapseTagChecked:item.checked}" v-for="item in digestiveTagList" :key=item.id>
                          {{item.name}}
                        </div>
                      </div>
                    </van-collapse-item>
                    <van-collapse-item name="2">
                      <template #title>
                        <div style="display:flex;align-items: center;margin-left:-1%;margin-right:2%">
                          <img v-show="!activeNames.includes('2')" style="height:3vh;" src="../../assets/tagImg/zhongliu1.png" />
                          <img v-show="activeNames.includes('2')" style="height:3vh;" src="../../assets/tagImg/zhongliu2.png" />
                        </div>
                        <span>肿瘤领域</span>
                      </template>
                      <span class="collapseItemH">选择感兴趣的适应症:</span>
                      <div class="collapseItemB">
                        <div class="tagItem" @click="selectTag(item)" :class="{collapseTagChecked:item.checked}" v-for="item in tumourTagList" :key=item.id>
                          {{item.name}}
                        </div>
                      </div>
                    </van-collapse-item>
                    <van-collapse-item name="3">
                      <template #title>
                        <div style="display:flex;align-items: center;margin-left:-1%;margin-right:2%">
                          <img v-show="!activeNames.includes('3')" style="height:3vh;" src="../../assets/tagImg/xueye1.png" />
                          <img v-show="activeNames.includes('3')" style="height:3vh;" src="../../assets/tagImg/xueye2.png" />
                        </div>
                        <span>血液制品领域</span>
                      </template>
                      <span class="collapseItemH">选择感兴趣的适应症:</span>
                      <div class="collapseItemB">
                        <div class="tagItem" @click="selectTag(item)" :class="{collapseTagChecked:item.checked}" v-for="item in bloodProductTagList" :key=item.id>
                          {{item.name}}
                        </div>
                      </div>
                    </van-collapse-item>
                    <van-collapse-item title="血友病及罕见病领域" name="4">
                      <template #title>
                        <div style="display:flex;align-items: center;margin-left:-1%;margin-right:2%">
                          <img v-show="!activeNames.includes('4')" style="height:3vh;" src="../../assets/tagImg/xueyou1.png" />
                          <img v-show="activeNames.includes('4')" style="height:3vh;" src="../../assets/tagImg/xueyou2.png" />
                        </div>
                        <span>血友病及罕见病领域</span>
                      </template>
                      <span class="collapseItemH">选择感兴趣的适应症:</span>
                      <div class="collapseItemB">
                        <div class="tagItem" @click="selectTag(item)" :class="{collapseTagChecked:item.checked}" v-for="item in hemophiliaTagList" :key=item.id>
                          {{item.name}}
                        </div>
                      </div>
                    </van-collapse-item>
                    <van-collapse-item title="其他" name="5">
                      <template #title>
                        <div style="display:flex;align-items: center;margin-left:-1%;margin-right:2%">
                          <img v-show="!activeNames.includes('5')" style="height:3vh;" src="../../assets/tagImg/qita1.png" />
                          <img v-show="activeNames.includes('5')" style="height:3vh;" src="../../assets/tagImg/qita2.png" />
                        </div>
                        <span>其他</span>
                      </template>
                      <span class="collapseItemH">选择感兴趣的适应症:</span>
                      <div class="collapseItemB">
                        <div class="tagItem" @click="selectTag(item)" :class="{collapseTagChecked:item.checked}" v-for="item in otherTagList" :key=item.id>
                          {{item.name}}
                        </div>
                      </div>
                    </van-collapse-item>
                  </van-collapse>
                </div>



                <div class="popupFoot">
                  <span style="margin-left:4.03%;margin-top:2.267vh;display:inline-block;font-weight: bold;font-size:1.067rem;color:#1a1a1a">文章类型</span>
                  <span style="margin-top:2.367vh;display:inline-block;font-size:0.8667rem;color:#1a1a1a">(点击选择感兴趣的文章类型)</span>
                  <div class="collapseItemF">
                    <div class="tagItemF" @click="selectTag(articleTypeTagList[0])" :class="{collapseTagChecked:articleTypeTagList[0].checked}">
                      指南解读
                    </div>
                    <div class="tagItemF" @click="selectTag(articleTypeTagList[1])" :class="{collapseTagChecked:articleTypeTagList[1].checked}">
                      文献解读
                    </div>
                    <div class="tagItemF" style="margin-right:0" @click="selectTag(articleTypeTagList[2])" :class="{collapseTagChecked:articleTypeTagList[2].checked}">
                      临床经典
                    </div>
                    <div class="tagItemF" @click="selectTag(articleTypeTagList[3])" :class="{collapseTagChecked:articleTypeTagList[3].checked}">
                      专家观点
                    </div>
                    <div class="tagItemF" @click="selectTag(articleTypeTagList[4])" :class="{collapseTagChecked:articleTypeTagList[4].checked}">
                      会议相关
                    </div>
                    <div class="tagItemF" style="margin-right:0" @click="selectTag(articleTypeTagList[5])" :class="{collapseTagChecked:articleTypeTagList[5].checked}">
                      其他资讯
                    </div>
                  </div>
                </div>


                <div class="popupBody2">
                  <div style="display: flex;flex-direction: column;">
                    <div>
                      <span style="margin-left:4.03%;margin-top:2vh;display:inline-block;font-weight: bold;font-size:1.067rem;color:#1a1a1a">自定义标签</span>
                      <span style="margin-top:2.1vh;display:inline-block;font-size:0.8667rem;color:#1a1a1a">(请输入感兴趣的自定义标签)</span>
                    </div> 
                    <div style="display:flex;justify-content: center;">
                      <input type="text" maxlength="20" v-model="personallytag" style="border-style: solid;border-color: black;height:3vh;width:81vw;border-radius:8px;margin-top:1.8vh;margin-bottom:1vh;line-height:3vh;padding:0.2vh 1.2vw;font-size:0.9rem">
                    </div>
                  </div>
                </div>

                <div style="display:flex">
                  <div class="clearButton" @click="clearTag()">清空</div>
                  <div class="confirmButton" @click="confirmTag()">确认</div>
                </div>
                
              </div>
        
            </van-popup>
          </div>

          
        </div>
        <!-- <div style="width:90%;margin: 0 auto;margin-top:-5px;margin-bottom:15px" v-if="!isPromotion">
          此页面以下均为“产品知识”相关内容
        </div>
        <div style="width:90%;margin: 0 auto;margin-top:-5px;margin-bottom:15px" v-if="isPromotion">
          此页面以下均为“疾病教育”相关内容
        </div> -->
        <div class="artical-list p_r">
          <!--@needReflash="needReflash"-->
          <!-- <allScorllPlace style="z-index: 1" ref="scorll"  @getNextPage="getNextPage" class="allScorllPlace" :style="{ top: 350 + 'px' }" v-if="totalArticleList.length > 0" :noNeedFlash="true"> -->
            <van-list
              class="vantList"
              v-if="totalArticleList.length > 0"
              style="z-index: 1;"
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad">
            <div class="artical-item" v-for="(item, index) in totalArticleList" :key="index">
              <div class="artical-item-pic" @click="goJumpLink($event,item,true)">
                <img class="img" :src="baseUrl + '/api/Article/file/' + item.fileID" alt="">
              </div>
              <div class="artical-item-info">
                <!-- 渐变线条 -->
                <div class="colorful-boder"></div>
                <div class="right" style="width: 100%">
                  <div class="item-info-title NoWrap">
                    {{item.title}}
                  </div>
                  <div class="item-info-read d_in v_m">
                    <i class="icon iconfont iconcalendar" style="color: rgb(137,137,137);" v-if="item.firstSubmitTime"></i>
                    <span class="num">{{item.firstSubmitTime ? $commonJs.returnDate(item.firstSubmitTime, 'YYMMDD1') : ''}}</span>
                  </div>
                  <div class="item-info-read d_in v_m">
                    <i class="icon iconfont iconkaiyanjing" style="color: rgb(137,137,137);"></i>
                    <span class="num">{{item.viewCount}}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div v-if="notList" style="text-align:center;color:rgb(137,137,137);">没有更多了</div> -->
            </van-list>
          <!-- </allScorllPlace> -->
          <!--<template v-if="totalArticleList.length > 0">-->
          <!--  <div class="artical-item" v-for="(item, index) in totalArticleList" :key="index">-->
          <!--    <div class="artical-item-pic" @click="goJumpLink($event,item)">-->
          <!--      <img class="img" :src="baseUrl + '/api/Article/file/' + item.fileID" alt="">-->
          <!--    </div>-->
          <!--    <div class="artical-item-info">-->
          <!--      &lt;!&ndash; 渐变线条 &ndash;&gt;-->
          <!--      <div class="colorful-boder"></div>-->
          <!--      <div class="right">-->
          <!--        <div class="item-info-title">-->
          <!--          {{item.title}}-->
          <!--        </div>-->
          <!--        <div class="item-info-read">-->
          <!--          <span class="num">{{item.viewCount}}</span>-->
          <!--          <i class="icon iconfont iconkaiyanjing" style="color: rgb(137,137,137);"></i>-->
          <!--        </div>-->
          <!--      </div>-->
          <!--    </div>-->
          <!--  </div>-->
          <!--  <div v-if="notList" style="text-align:center;color:rgb(137,137,137);">没有更多了</div>-->
          <!--</template>-->
          <div v-else style="text-align:center;margin-top: 50px;">
            {{noDataText}}
          </div>
        </div>
      </div>
    </div>
    <div v-if="showGuide" class="guideTofollowImg">
      <img src="../../assets/guide_background_prod.png" />
    </div>
    <agreeBookDialog :ABDialogShow="ABDialogShow" :openId="openId" @ABDialogShowFn="ABDialogShowFn"></agreeBookDialog>
  </div>
</template>
<script>
import Vue from 'vue'
import {Popup} from 'vant'
import {Button} from 'vant'
import { Collapse, CollapseItem } from 'vant';
import 'vant/lib/collapse/style';
import 'vant/lib/collapse-item/style';
Vue.use(Popup)
Vue.use(Button)
Vue.use(Collapse);
Vue.use(CollapseItem);
import { List } from "vant"
import agreeBookDialog from "./agreeBookDialog";
import merge from 'webpack-merge';
import { swiper, swiperSlide } from "vue-awesome-swiper"
import "swiper/dist/css/swiper.css"
export default {
  name: 'countyCollections',
  components: {
    swiper,
    swiperSlide,
    agreeBookDialog,
    [List.name]: List
  },
  data () {
    return {
      activeTab:0,
      showCarousel:true,
      showTag: false,
      activeNames: ['0'],
      digestiveTagList:[],//消化领域
      tumourTagList:[],//肿瘤领域
      bloodProductTagList:[],//血液制品领域
      hemophiliaTagList:[],//血友病及罕见病领域
      otherTagList:[],//其他
      personallytag:"",//自定义标签
      isSearchTag:false,//是否进行标签搜索的操作
      searchId:"",
      articleTypeTagList:[
        {
          id:22,
          name:"指南解读",
          field:"文章类型",
          checked:false
        },
        {
          id:23,
          name:"文献解读",
          field:"文章类型",
          checked:false
        },
        {
          id:24,
          name:"临床经典",
          field:"文章类型",
          checked:false
        },
        {
          id:25,
          name:"专家观点",
          field:"文章类型",
          checked:false
        },
        {
          id:26,
          name:"会议相关",
          field:"文章类型",
          checked:false
        },
        {
          id:27,
          name:"其他资讯",
          field:"文章类型",
          checked:false
        }
      ],//文章类型
      loading: true,
      finished: false,
      baseUrl: process.env.config.baseUrl,
      showPage: false,
      showHeadMenu: false,
      openId: '',
      returnurl: decodeURIComponent(this.$route.query.returnurl || ''),
      oriUrl: this.$route.query.returnurl || '',
      takedacode: this.$route.query.takedacode || '',
      jumptovctag: this.$route.query.jumptovctag || '',
      NewerTag: this.$route.query.NewerTag || '',
      showGuide: false,
      userInfo: {},
      ABDialogShow:false,
      fieldsList: [],
      indicationList: [],
      showFieldsList: false,
      carouselList: [],
      articleList: [],
      totalArticleList: [],
      swiperOption: {
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      noDataText: '',
      pageIndex: 1,
      pageSize: 5,
      isHot: false,
      isPromotion: false,
      total: 0,
      totalPage: 0,
      skipcarouselCount: 0,
      containerHeight: 0,
      notList: false,
      testSwitch: false
    }
  },
  destroyed () {
    // this.$nextTick(() => {
    //   window.removeEventListener('click', this.scrollHandler, true)
    // })
  },
   created () {
    this.pageIndex = 1

//判断会传参数中是否有 jumptovctag ，如有则证明已经跳过了，如无，则无论如何都跳转
if(!this.jumptovctag){
  let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/countyCollections?returnurl=' + encodeURIComponent((this.oriUrl || '')))
      window.location.href = url
 }

     //如果参数中含有新用户标记，则清理缓存 (当前未考虑员工，仅考虑了医生)
     if(this.NewerTag=='Hcp'){
      window.sessionStorage.removeItem("LsData");
                // 注册成功删除暂存的用户信息
      window.localStorage.removeItem("registerUserInfo");
      window.localStorage.removeItem("registerNonHCPInfo");
                // 删除员工标识
      window.localStorage.removeItem("isEmployee");
    }
    else if(this.NewerTag=='Emp')
    {
      window.localStorage.setItem('isEmployee', true);

    }
    else if(this.NewerTag=='NoHcp')
    {
      window.localStorage.removeItem("registerNonHCPInfo");
      window.localStorage.removeItem("registerUserInfo");
    }

    if (!localStorage.TaToken && !this.takedacode) {
      let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/countyCollections?returnurl=' + encodeURIComponent((this.oriUrl || '')))
      window.location.href = url
    } else {
      if (this.takedacode && !localStorage.TaToken) {
        this.$axiox.get('/Login/GetTokenByCode?code=' + this.takedacode).then(msg => {
          localStorage.TaToken = msg.token
          localStorage.appId = msg.appId
          localStorage.openId = msg.openId
          this.openId = msg.openId
          let isEmployee = window.localStorage.getItem('isEmployee')
          let allAxiox = ''
          if (isEmployee) {
            let data = {
              openId: this.openId,
              returnurl: encodeURIComponent(this.returnurl)
            }
            allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getEmployee', data)
          } else {
            let data = {
              openid: this.openId,
              returnurl: encodeURIComponent(this.returnurl)
            }
            allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getDoctor', data)
          }

          if(this.NewerTag=='NoHcp'){

            this.$commonJs.mobileDoubleComfirm({
            buttonType: "0",
            type: "warning",
            title: "提示",
            content:
              "该平台仅供医疗卫生专业人士（HCP）使用，您已注册非HCP，暂无权限！",
            successFun: () => {
            },
            errorFun: (err) => {},
          });

          }

          allAxiox.then(msg => {
            console.log(msg, 'getDoctor')
            if (msg.isSuccess) {
              if (msg.data.status === 2) {
                //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
              } else if (msg.data.status === 3) {
                //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
              } else {
                if (msg.data.isFollowed) {
                  this.showPage = true
                  this.getUserInfo()
                } else {
                  this.showGuide = true
                }
              }
            }
          })
        })
      } else {
        this.openId = localStorage.openId
        let isEmployee = window.localStorage.getItem('isEmployee')
        let allAxiox = ''
        if (isEmployee) {
          let data = {
            openId: this.openId,
            returnurl: encodeURIComponent(this.returnurl)
          }
          allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getEmployee', data)
        } else {
          let data = {
            openid: this.openId,
            returnurl: encodeURIComponent(this.returnurl)
          }
          allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getDoctor', data)
        }

        if(this.NewerTag=='NoHcp'){

this.$commonJs.mobileDoubleComfirm({
buttonType: "0",
type: "warning",
title: "提示",
content:
  "该平台仅供医疗卫生专业人士（HCP）使用，您已注册非HCP，暂无权限！",
successFun: () => {
},
errorFun: (err) => {},
});

}



        allAxiox.then(msg => {
          console.log(msg, 'getDoctor')
          if (msg.isSuccess) {
            if (msg.data.status === 2) {
              //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
            } else if (msg.data.status === 3) {
              //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
            } else {
              if (msg.data.isFollowed) {
                this.showPage = true
                this.getUserInfo()
              } else {
                this.showGuide = true
              }
            }
          }
        })
      }
    }
  
      setTimeout(() => {
        this.getSignDetail();
        this.$router.push({
 query:merge(this.$route.query,{'jumptovctag':''})
 })
      }, 1000);
     this.getAllTags()
   },
  mounted () {
    document.title = '血液制品专区'
    // 监听如果页面发生滚动时
    // this.$nextTick(() => {
    //   window.addEventListener('click', this.scrollHandler, true)
    // })
    window.removeEventListener('click', this.closeFavourite, false)
    window.addEventListener('click', this.closeFavourite, false)
  },
  methods: {
    toolClick(type){
      if(type=='1'){
        this.$commonJs.showTips('敬请期待')
      }else if(type=='2'){
        this.$commonJs.showTips('敬请期待')
      }else if(type=='3'){
        this.$commonJs.showTips('敬请期待')
      } 
    },
    changeTab(index){
      this.activeTab=index
    },
    getSignDetail() {
      let data = {
        openid: this.openId,
        docCode: "",
      };
      this.$axiox.postNoRes("/api/hcp/getHcpSignDetail", data).then((p) => {
        if (p.data == "True") {

          if(this.showGuide!=true){
          //name: "agreeBook",
          this.ABDialogShow = true
          }

          
        } else if (p.data == "False") {
        } //无需重新签署
        else {
        } //返回值错误
      });
    },
    ABDialogShowFn() {
      this.ABDialogShow =false;
    },
    test(){},
    closeFavourite(){
      this.showFieldsList = false
    },
    onLoad () {
      if (this.total > this.totalArticleList.length) {
        this.loading = true
        this.pageIndex += 1
        //let fields = this.fieldsList.filter(val => val.checked)
        let fields = []
        fields = this.digestiveTagList.concat(this.tumourTagList).concat(this.bloodProductTagList).concat(this.hemophiliaTagList).concat(this.otherTagList).concat(this.articleTypeTagList)
        fields = fields.filter(val => val.checked)
        this.getArticals(this.userInfo.department, fields,false)
      } else {
        this.notList = true
        this.finished = true
      }
    },
    toggleHeadMenu () {
      this.showHeadMenu = !this.showHeadMenu
    },
    searchHandler () {
      console.log(this.$route.query, 'query')
      let queries = this.$route.query
      this.$router.push({
        path: '/countySearchList',
        query: {
          skipcarouselCount: this.skipcarouselCount,
          fieldsList: JSON.stringify(this.fieldsList),
          ...queries
        }
      })
    },
    // 获取用户信息
    getUserInfo () {
      let isEmployee = window.localStorage.getItem('isEmployee')
      let requestUrl2 = ''
      if (isEmployee) {
        requestUrl2 = this.$axiox.getNoRes('/Login/EmployeeWxUserInfo?openId=' + this.openId)
      } else {
        let data = {
          openId: this.openId
        }
        requestUrl2 = this.$axiox.postNoRes('/Login/WxUserInfo', data)
      }
      requestUrl2.then(msg => {
        console.log(msg, 'msg')
        if (msg.isSuccess) {
          this.userInfo = msg.data
          // 获取领域
          if (msg.data.fields) {
            this.getFieldsList(msg.data.fields)
          } else {
            this.getFieldsList()
          }
        }
      })
    },
    // 获取领域
    getFieldsList (fields) {
      this.$axiox.get(`/api/Dict/GetFields`).then(res => {
        console.log(res, 'getFieldsList')
        if (fields && fields.length > 0) {
          this.fieldsList = res.map(val => {
            return {
              checked: fields.some(v => v.name === val.name),
              ...val
            }
          })
          // 获取轮播图
          this.getCarouselArticles(this.userInfo.department, this.userInfo.fields)
        } else {
          this.fieldsList = res.map(val => {
            return {
              checked: false,
              ...val
            }
          })
          // 获取轮播图
          this.getCarouselArticles(this.userInfo.department, [])
        }
      })
    },
    chooseFields (item) {
      this.totalArticleList = []
      this.pageIndex = 1

      item.checked = !item.checked
      let fields = this.fieldsList.filter(val => val.checked)
      // // 获取推荐文章
      // this.getArticals(this.userInfo.department, fields)
      // 获取推荐轮播图
      this.getCarouselArticles(this.userInfo.department, fields)
    },
    openFieldsList (e) {
      e.stopPropagation();
      // e.preventDefault()
      //this.showFieldsList = !this.showFieldsList
      this.showTag = true
    },
    confirmTag(){
      this.totalArticleList = []
      this.pageIndex = 1
      let fields = []
      fields = this.digestiveTagList.concat(this.tumourTagList).concat(this.bloodProductTagList).concat(this.hemophiliaTagList).concat(this.otherTagList).concat(this.articleTypeTagList)
      fields = fields.filter(val => val.checked)
      this.getArticals(this.userInfo.department, fields,true)
      this.showTag = false
    },
    getAllTags(){
      this.$axiox.get("/api/Dict/QueryFieIDIndication").then(res => {
        this.digestiveTagList=res.filter(val => val.field=="消化领域")
        this.tumourTagList=res.filter(val => val.field=="肿瘤领域")
        this.bloodProductTagList=res.filter(val => val.field=="血液制品领域")
        this.hemophiliaTagList=res.filter(val => val.field=="血友病与罕见病领域")
        this.otherTagList=res.filter(val => val.field=="其它")
      })
    },
    popupOpen(){
      this.showCarousel=false
    },
    popupClosed(){
      this.showCarousel=true
    },
    selectTag(item){
      item.checked=!item.checked
      //console.log("this.digestiveTagList:",this.digestiveTagList)
    },
    clearTag(){
      for(let i=0;i<this.digestiveTagList.length;i++){
        this.digestiveTagList[i].checked=false
      }
      for(let i=0;i<this.tumourTagList.length;i++){
        this.tumourTagList[i].checked=false
      }
      for(let i=0;i<this.bloodProductTagList.length;i++){
        this.bloodProductTagList[i].checked=false
      }
      for(let i=0;i<this.hemophiliaTagList.length;i++){
        this.hemophiliaTagList[i].checked=false
      }
      for(let i=0;i<this.otherTagList.length;i++){
        this.otherTagList[i].checked=false
      }
      for(let i=0;i<this.articleTypeTagList.length;i++){
        this.articleTypeTagList[i].checked=false
      }
      this.personallytag=""
    },
    // 获取轮播图
    getCarouselArticles (department, fields) {
      let fieldNames = fields.map(val => val.name)
      let str = ''
      fieldNames.forEach(item => {
        str = str + '&fieldNames=' + item
      })
      console.log(str, 'str')
      let url = ''
      if (department || (fieldNames && fieldNames.length > 0)) {
        // url = `/api/minisite/CarouselArticles?department=${department}` + str
        url = `/api/minisite/CarouselArticlesCountry?t=${new Date().getTime()}` + str
      } else {
        url = `/api/minisite/CarouselArticlesCountry`
      }
      this.$axiox.get(url).then(res => {
        console.log(res, 'Carousel')
        if (res.articles && res.articles.length > 0) {
          this.carouselList = res.articles
          this.skipcarouselCount = res.articles.length
        } else {
          this.carouselList = []
          this.skipcarouselCount = 0
        }
        // 获取推荐文章
        //let fields = this.fieldsList.filter(val => val.checked)
        let fields = []
        fields = this.digestiveTagList.concat(this.tumourTagList).concat(this.bloodProductTagList).concat(this.hemophiliaTagList).concat(this.otherTagList).concat(this.articleTypeTagList)
        fields = fields.filter(val => val.checked)
        this.getArticals(this.userInfo.department, fields,false)
        this.swiperOption.autoplay = {
          delay: res.durationTime * 1000, // 轮播图时长
          stopOnLastSlide: false,
          disableOnInteraction: false
        }
        // this.$nextTick(() => {
        //   setTimeout(t => {
        //     let swiperDom = document.getElementById('carousel-list')
        //     console.log(swiperDom.offsetHeight, 'offsetHeight')
        //     this.containerHeight = swiperDom.offsetHeight - 60
        //   }, 300)
        // })
      })
    },
    changeIsNew(){
      console.log(this.isHot)
      //let fields = this.fieldsList.filter(val => val.checked)
      let fields = []
      fields = this.digestiveTagList.concat(this.tumourTagList).concat(this.bloodProductTagList).concat(this.hemophiliaTagList).concat(this.otherTagList).concat(this.articleTypeTagList)
      fields = fields.filter(val => val.checked)
      this.totalArticleList = []
      this.pageIndex = 1
      this.getArticals(this.userInfo.department, fields,false)
    },
    changeIsPromotion(){
      let fields = []
      fields = this.digestiveTagList.concat(this.tumourTagList).concat(this.bloodProductTagList).concat(this.hemophiliaTagList).concat(this.otherTagList).concat(this.articleTypeTagList)
      fields = fields.filter(val => val.checked)
      this.totalArticleList = []
      this.pageIndex = 1
      this.getArticals(this.userInfo.department, fields,false)
    },
    // 获取推荐文章
    getArticals (department, fields,isLog) {
      console.log(department, fields, 'department, fields')
      this.notList = false
      this.finished = false
      let fieldNames = fields.map(val => val.name)
      let str = ''
      fieldNames.forEach(item => {
        str = str + '&fieldNames=' + item
      })
      console.log(str, 'str')
      let url = ''
      if (department || (fieldNames && fieldNames.length > 0)) {
        //url = `/api/minisite/QueryMinisiteArticles?t=${new Date().getTime()}&keywords=${''}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}&isnew=${!this.isHot}` + str
        // url = `/api/minisite/QueryMinisiteArticlesByTag?t=${new Date().getTime()}&keywords=${''}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}&isnew=${!this.isHot}` + str
        url = `/api/minisite/QueryMinisiteArticlesByTagCounrty?t=${new Date().getTime()}&keywords=${''}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}&isnew=${!this.isHot}&isPromotion=${this.isPromotion}&personallytag=${this.personallytag}` + str

        // url = `/api/minisite/QueryMinisiteArticles?t=${new Date().getTime()}&keywords=${''}&skipcarouselCount=${this.skipcarouselCount}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}&isnew=${!this.isHot}` + str
        // url = `/api/minisite/QueryMinisiteArticles?department=${department}&keywords=${''}&skipcarouselCount=${this.skipcarouselCount}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}` + str
      } else {
        //url = `/api/minisite/QueryMinisiteArticles?keywords=${''}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}&isnew=${!this.isHot}`
        // url = `/api/minisite/QueryMinisiteArticlesByTag?keywords=${''}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}&isnew=${!this.isHot}`
        url = `/api/minisite/QueryMinisiteArticlesByTagCounrty?keywords=${''}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}&isnew=${!this.isHot}&isPromotion=${this.isPromotion}&personallytag=${this.personallytag}`

        // url = `/api/minisite/QueryMinisiteArticles?keywords=${''}&skipcarouselCount=${this.skipcarouselCount}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}&isnew=${!this.isHot}`
      }
      this.$axiox.getList(url).then(res => {
        console.log(res, 'getArticals')
        setTimeout(() => {
          this.loading = false
        }, 500)

        if(isLog){
          if((fieldNames && fieldNames.length > 0) || this.personallytag){
            let NormalTag=''
            fieldNames.forEach(item => {
              NormalTag = NormalTag + item +','
            })
            NormalTag=NormalTag.substring(0,NormalTag.length-1)
            let url1=`/api/minisite/TagSearchLogInter?Openid=${this.openId}&NormalTag=${NormalTag}&PersonalTag=${this.personallytag}&CountryInfo=Country`
            this.$axiox.getList(url1).then(res1=>{
              if (res.data && res.data.length > 0) {
                for(let i = 0; i < res.data.length; i++) {
                  this.totalArticleList.push(res.data[i])
                }
                this.total = res.total
                this.totalPage = Math.ceil(res.total / this.pageSize)
              } else {
                for(let i = 0; i < res.data.length; i++) {
                  this.totalArticleList.push(res.data[i])
                }
                this.total = 0
                this.totalPage = 0
                this.noDataText = '更多精彩内容，敬请期待！'
              }
              this.searchId=res1.data[0].logid
              this.isSearchTag=true
            })
          }else{
            if (res.data && res.data.length > 0) {
              for(let i = 0; i < res.data.length; i++) {
                this.totalArticleList.push(res.data[i])
              }
              this.total = res.total
              this.totalPage = Math.ceil(res.total / this.pageSize)
            } else {
              for(let i = 0; i < res.data.length; i++) {
                this.totalArticleList.push(res.data[i])
              }
              this.total = 0
              this.totalPage = 0
              this.noDataText = '更多精彩内容，敬请期待！'
            }
            this.searchId=""
            this.isSearchTag=false
          }
        }else{
          if (res.data && res.data.length > 0) {
            for(let i = 0; i < res.data.length; i++) {
              this.totalArticleList.push(res.data[i])
            }
            this.total = res.total
            this.totalPage = Math.ceil(res.total / this.pageSize)
          } else {
            for(let i = 0; i < res.data.length; i++) {
              this.totalArticleList.push(res.data[i])
            }
            this.total = 0
            this.totalPage = 0
            this.noDataText = '更多精彩内容，敬请期待！'
          }
        }
      })
    },
    // 去收藏页
    goFavoritesPage () {
      let queries = this.$route.query
      queries.from = 'countyCollections'
      // queries.returnurl = encodeURIComponent(window.location.href)
      this.$router.push({
        path: '/favConList',
        query: queries
      })
    },
    // 去个人中心
    goPersonalPage () {
      // let queries = this.$route.query
      // queries.from = 'countyCollections'
      // // queries.returnurl = encodeURIComponent(window.location.href)
      // this.$router.push({
      //   path: '/register',
      //   query: queries
      // })
      window.location.href = process.env.config.vcPersonalCenter
    },
    goJumpLink (e, slide,isList) {
      e.stopPropagation()
      console.log(slide, 'slide')
      let queries = JSON.parse(JSON.stringify(this.$route.query))
      queries.id = slide.articleId
      queries.source = 'WY'
      //queries.jumptovctag = ''
      queries.jumptovctag=this.jumptovctag
      let url = this.$commonJs.returnQuery('//' + window.location.host + '/mobileContent', queries)
      this.recordLog(slide.articleId,isList,url)
      //window.location.href = url
      // this.$router.push({
      //   path: '/mobileContent',
      //   query: {
      //     id: slide.articleId,
      //     source: 'WY',
      //     ...this.$route.query
      //   }
      // })
    },
    recordLog(id,isList,urla){
      if(this.isSearchTag && isList){
        let url=`/api/minisite/TagSearchArticleLogInter?ArticleID=${id}&TagLogGuid=${this.searchId}&Openid=${this.openId}`
        this.$axiox.getList(url).then(res=>{console.log(res);window.location.href = urla})
      }else{
        window.location.href = urla;
      }
    },
    needReflash () {
      this.pageIndex = 1
      //let fields = this.fieldsList.filter(val => val.checked)
      let fields = []
      fields = this.digestiveTagList.concat(this.tumourTagList).concat(this.bloodProductTagList).concat(this.hemophiliaTagList).concat(this.otherTagList).concat(this.articleTypeTagList)
      fields = fields.filter(val => val.checked)
      this.getArticals(this.userInfo.department, fields,false)
    },
    getNextPage () {
      if (this.total > this.totalArticleList.length) {
        this.pageIndex += 1
        //let fields = this.fieldsList.filter(val => val.checked)
        let fields = []
        fields = this.digestiveTagList.concat(this.tumourTagList).concat(this.bloodProductTagList).concat(this.hemophiliaTagList).concat(this.otherTagList).concat(this.articleTypeTagList)
        fields = fields.filter(val => val.checked)
        this.getArticals(this.userInfo.department, fields,false)
      } else {
        this.notList = true
        this.finished = true
      }
    },
    scrollHandler () {
      var scrollTop = document.documentElement.scrollTop // 滚动条的位置
      var windowHeitht = document.documentElement.clientHeight // 在页面上返回内容的可视高度
      var scrollHeight = document.documentElement.scrollHeight // 返回整个元素的高度（包括带滚动条的隐蔽的地方）
      // 是否滚动到底部的判断
      if (scrollHeight - windowHeitht - scrollTop < 40) {
        console.log('滚到底了')
       
        // 页数加1
        // this.pageIndex += 1
        if (this.pageIndex <= this.totalPage) {
          this.pageIndex += 1
          // 获取推荐文章
          //let fields = this.fieldsList.filter(val => val.checked)
          let fields = []
          fields = this.digestiveTagList.concat(this.tumourTagList).concat(this.bloodProductTagList).concat(this.hemophiliaTagList).concat(this.otherTagList).concat(this.articleTypeTagList)
          fields = fields.filter(val => val.checked)
          this.getArticals(this.userInfo.department, fields,false)
        } else {
          this.notList = true
          this.finished = true
          return
        }
      }
    }
  },
  computed: {
    swiper() {
      this.$nextTick(() => {
        return this.$refs.mySwiper.swiper;
      })
    }
  },
}
</script>
<style scoped>
  #countyCollections {
    width: 100%;
  }
  .top-header {
    width: 100%;
    height: 60px;
  }
  .header-bg {
    width: 100%;
    height: 90px;
    background-color: #FF4D4F;
    border-radius: 0px 0px 45px 45px;
    display: flex;
    flex-direction: row;
    padding: 15px 20px;
    box-sizing: border-box;
    justify-content: space-around;
    padding-right: 0;
  }
  .search {
    width: 250px;
    height: 35px;
    position: relative;
  }
  .searchBar {
    width: 250px;
    height: 35px;
    line-height: 35px;
    border: none;
    border-radius: 30px;
    background-color: #E71222;
    box-sizing: border-box;
    color: #ffffff;
    box-shadow: 0px 2px 6px -2px rgba(0, 0, 0, 0.4);
  }
  .search-icon {
    color: #ffffff;
    position: absolute;
    left: 3px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 27px!important;
    font-weight: bold;
  }
  .empty-icon {
    color: #ffffff;
    position: absolute;
    right: 3px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 27px!important;
    font-weight: bold;
  }
  .top-menu {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background-color: #E71222;
    text-align: center;
    box-shadow: 0px 2px 6px -2px rgba(0, 0, 0, 0.4);
    position: relative;
  }
  .top-menu-active {
    background-color: #ffffff;
  }
  .top-menu-list {
    width: 100px;
    background-color: #FFFFFF;
    padding: 15px 5px;
    border-radius: 10px;
    position: absolute;
    right: 22px;
    top: 28px;
    z-index: 2;
    box-shadow: 0px 0px 6px -2px rgba(0, 0, 0, 0.4);
  }
  .menu-icon {
    color: #ffffff;
    line-height: 35px;
  }
  .menu-icon-active {
    color: #E71222;
  }
  .carousel-container {
    width: 90%;
    /* height: 160px; */
    /*height: 100px;*/
    margin: 0 auto;
    position: relative;
  }
  .carousel-list {
    width: 100%;
    /* height: 220px; */
    margin: 0 auto;
    border-radius: 15px;
  }
  .my-swp-silde {
    width: 100%;
    position: relative;
  }
  .my-swp-silde .my-swp-img {
    display: block;
    width: 100%;
    height: 100%;
  }
  .swiper-pagination >>> .swiper-pagination-bullet-active {
    background: #EF1201!important;
  }
  .my-slide-name {
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    background-color: rgba(255,255,255, 0.5);
    color: #333333;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .artical-container {
    width: 100%;
    background-color: #ffffff;
    border-radius: 45px 45px 0px 0px;
    /* min-height: 502px; */
    min-height: 488px;
    padding-bottom: 50px;
    padding-top: 30px;
    
    position: relative;
    z-index: 0;
  }
  .artical-header {
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  .recommend,
  .interest {
    height: 30px;
    box-sizing: border-box;
  }
  .interest {
    border-radius: 20px;
    border: 1px solid #E71222;
    padding: 0 15px;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
  }
  .recommend-txt,
  .interest-txt {
    color: rgb(16, 16, 16);
    font-size: 16px;
    text-align: left;
    font-family: SourceHanSansSC-regular;
    line-height: 30px;
    margin-left: 5px;
  }
  .interest-txt {
    color: #E71222;
  }
  .artical-list {
    width: 90%;
    margin: 0 auto;
  }
  .artical-item {
    width: 100%;
    margin-bottom: 20px;
  }
  .artical-item-pic {
    overflow: hidden;
    border-radius: 15px;
    box-shadow: 0px 2px 6px -2px rgba(0, 0, 0, 0.4);
  }
  .artical-item-pic .img {
    display: block;
    width: 100%;
  }
  .artical-item-info {
    display: flex;
    flex-direction: row;
    margin-top: 6px;
  }
  .colorful-boder {
    min-height: 40px;
    width: 10px;
    border-radius: 15px;
    background-image: linear-gradient(to bottom, #E71222, #FBAEA6);
  }
  .right {
    padding: 5px 7px;
  }
  .right .item-info-title {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
  }
  .right .item-info-read {

  }
  .right .item-info-read .num {
    /* color: rgb(192,192,192); */
    color: rgb(137,137,137);
    font-size: 12px;
    margin-right: 5px;
  }
  .indicationList {
    width: 170px;
    /* height: 120px;
    min-height: 120px; */
    position: absolute;
    top: 35px;
    right: 0px;
    padding: 15px;
    background: rgba(255,255,255, 0.8);
    border-radius: 10px;
    border: 1px solid #C5C5C5;
    overflow: auto;
    z-index: 3;
  }
  .indicationList ul {
    width: 100%;
    margin: 0 auto;
  }
  .indicationList ul li {
    width: 100%;
    /* height: 30px; */
    height: auto;
    /* line-height: 30px; */
    background-color: #ffffff;
    border: 1px solid #C5C5C5;
    color: #666666;
    box-sizing: border-box;
    text-align: center;
    border-radius: 4px;
    margin-top: 15px;
    padding: 5px 0;
  }
  .indicationList ul li.active {
    color: #EF1201;
    border: 1px solid #EF1201;
  }
  .vantList >>> .van-loading__spinner.van-loading__spinner--circular{
    display: none;
  }
  .vantList >>> .van-list__finished-text{
    text-align:center;
    color:rgb(137,137,137);
  }

  .imgLink{
    width: 90%;
    margin: 0px auto;
    margin-bottom: 10px;
    position: relative;
  }
  .imgLink .leftBox{
    width: 60%;
    height: 80%;
    background: linear-gradient(90deg, rgba(255, 238, 220, 1) 0%, rgba(255, 247, 226, 1) 100%);
    position: absolute;
    top:10%;
    left:2%;
  }
  .imgLink .leftBox .leftBoxTop{
    font-family: 'Arial Negreta cursiva', 'Arial Normal', 'Arial';
    font-weight: 700;
    font-style: italic;
    font-size: 20px;
    color: #5E341E;
    position: absolute;
    top:17%;
    left:7%;
  }
  .imgLink .leftBox .leftBoxBottom{
    font-family: 'Arial Normal', 'Arial';
    font-weight: 400;
    font-size: 14px;
    font-style: normal;
    color: black;
    position: absolute;
    bottom:15%;
    left:7%;
  }

  .tabParent{
    width:230px;
    height:30px;
    background:#C73343;
    border-radius: 100px;
    position: relative;
  }

  .tabChild1{
    height:26px;
    width: 55px;
    border-radius:100px;
    line-height:26px;
    text-align: center;
    position: absolute;
    left:2px;
    top:2px;
    font-size:12px;
  }
  .tabChild2{
    height:26px;
    width:55px;
    border-radius:100px;
    line-height:26px;
    text-align: center;
    position: absolute;
    left:59px;
    top:2px;
    font-size:12px;
  }
  .tabChild3{
    height:26px;
    width: 55px;
    border-radius:100px;
    line-height:26px;
    text-align: center;
    position: absolute;
    left:116px;
    top:2px;
    font-size:12px;
  }
  .tabChild4{
    height:26px;
    width: 55px;
    border-radius:100px;
    line-height:26px;
    text-align: center;
    position: absolute;
    left:173px;
    top:2px;
    font-size:12px;
  }

  .tabActive{
    background-color: white;
    color: #C73343;
  }
  .tabNomal{
    background-color: #C73343;
    color: white;
  }

  .toolBox{
    width:90%;
    margin-left:5%;
    margin-bottom:20px;
    height:120px;
    border-radius:8px;
    background-color:rgba(255,243,243);
    position:relative;
    display:flex;
    justify-content:center;
  }
  .toolBoxInside{
    width:92%;
    border-radius:8px;
    padding-top:5px;
    padding-bottom:5px;
    display:flex;
    position:absolute;
    top:30px;
    background-color:white;
  }
  .DRGItem{
    display:flex;
    justify-content:space-around;
    flex-direction:column;
    align-items:center;
    width:33.3%;
    height:70px;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/countyCollections.vue